import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import { ProductType, Inspection, Inspector, ListFilters, ListResults, Policy } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeService {
  constructor(protected http: HttpClient) {}

  public list(filters?: ListFilters) {
    return this.http.get<ListResults<ProductType>>(`${env.APIUrl}/ProductType`, { params: filters as any }).toPromise();
  }

  public get(id: number) {
    return this.http.get<ProductType>(`${env.APIUrl}/ProductType/${id}`).toPromise();
  }

  public archived(filters?: ListFilters) {
    return this.http
      .get<ListResults<ProductType>>(`${env.APIUrl}/ProductType/archived`, { params: filters as any })
      .toPromise();
  }

  public archive(id: number) {
    return this.http.put<ProductType>(`${env.APIUrl}/ProductType/${id}/archive`, null).toPromise();
  }

  public restore(id: number) {
    return this.http.put<ProductType>(`${env.APIUrl}/ProductType/${id}/restore`, null).toPromise();
  }

  public edit(id: number, ProductType: ProductType) {
    return this.http.put<ProductType>(`${env.APIUrl}/ProductType/${id}`, ProductType).toPromise();
  }

  public create(ProductType: ProductType) {
    return this.http.post<ProductType>(`${env.APIUrl}/ProductType`, ProductType).toPromise();
  }

  public count() {
    return this.http.get<{ active: boolean; count: number }[]>(`${env.APIUrl}/ProductType/count`).toPromise();
  }
}
